module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABGdBTUEAALGPC/xhBQAAAFpJREFUWAnt1TEOACAIA0D1/39Wn9CBBBOPuSFwS8cwBAgQ+Ftgpu/vO2m2Mrcql9lFgAABAgTeE4i7OD29urN1cSovR4AAgSaBuEmqGyL9V5OkUnIECBBoEjhT+Qv+eNJppQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/menu@2x.png
// module id = dCxf
// module chunks = 1